import { Options } from 'highcharts';

/**
 * Base configuration for Highcharts
 * This serves as the foundation for all chart types
 */
export const baseChartOptions: Options = {
    chart: {
        animation: true,
        backgroundColor: 'transparent',
        borderWidth: 0,
        shadow: false,
        spacing: [10, 10, 15, 10], // top, right, bottom, left
        style: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        }
    },
    title: {
        text: undefined, // No title by default
        style: {
            fontSize: '16px',
            fontWeight: 'bold'
        }
    },
    subtitle: {
        text: undefined
    },
    credits: {
        enabled: false // Disable Highcharts credits
    },
    tooltip: {
        animation: true,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderWidth: 1,
        shadow: true,
        style: {
            fontSize: '12px'
        },
        shared: true
    },
    legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        itemStyle: {
            fontSize: '12px',
            fontWeight: 'normal'
        }
    },
    plotOptions: {
        series: {
            animation: {
                duration: 1000
            },
            states: {
                hover: {
                    enabled: true,
                    brightness: 0.1
                }
            },
            marker: {
                enabled: true,
                radius: 3,
                symbol: 'circle'
            },
            dataLabels: {
                enabled: false
            }
        }
    },
    xAxis: {
        title: {
            text: undefined
        },
        gridLineWidth: 0,
        lineWidth: 1,
        tickWidth: 1,
        labels: {
            style: {
                fontSize: '11px'
            }
        }
    },
    yAxis: {
        title: {
            text: undefined
        },
        gridLineWidth: 1,
        lineWidth: 0,
        tickWidth: 0,
        labels: {
            style: {
                fontSize: '11px'
            }
        }
    },
    colors: ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'],
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }
        ]
    },
    accessibility: {
        enabled: true
    },
    exporting: {
        // hide built in export menu
        enabled: false
    }
};
